import { ViewModel, ObservableArray, DelegatedObservableArrayChangeListenner } from "binder";
import { ComboBoxBaseViewModel } from "../comboBoxBase/comboBoxBase-viewModel";

export class ComboBoxViewModel extends ComboBoxBaseViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    public getTypeId(): string {
        return "VM-0ECE0A99-7FD1-417C-9E35-4336B354D01B"
    }

    public set selected(v: ViewModel) { 
        if(this._selected == v){
            return;
        }
        this._selected = v; 
        if(v)
            this.selectedItemsList.update(...[v]);
        else
            this.selectedItemsList.clear();
    } public get selected(): ViewModel { return this._selected;} private _selected: ViewModel;
    
    private _selectedItemsChangeListenner:DelegatedObservableArrayChangeListenner;
    public set selectedItemsList(v: ObservableArray<ViewModel>) {
        super.selectedItemsList = v; 

        if(this._selectedItemsList2){
            this.selectedItemsList.removeChangeListenner(this._selectedItemsChangeListenner);
        }
        this._selectedItemsList2 = v; 
        if(this._selectedItemsList2){
            this._selectedItemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.onSelectionChanged());
            this._selectedItemsList2.addChangeListenner(this._selectedItemsChangeListenner);
        }
    } public get selectedItemsList(): ObservableArray<ViewModel> { return this._selectedItemsList2;} private _selectedItemsList2: ObservableArray<ViewModel>;

    private onSelectionChanged(){
        if(this.selectedItemsList){
            this.selected = this.selectedItemsList.at(0);
        }
    }
}
